<template>
    <div class="block-editor probel-select-branch">
        <section class="active-connection">
            <div data-small="true" class="logos">
                <div class="logo1">
                    <img class="custom-block-logo" src="/static/img/supsis-logo2.png" />
                </div>
                <span class="material-icons"> add </span>
                <div class="logo2">
                    <img class="custom-block-logo" src="/static/img/chatbot/probel.png" />
                </div>
            </div>
            <div class="active-connection-text">
                <div><span>Connected with</span> <b> Probel API</b></div>
            </div>
        </section>
        <div class="probel-select-branch-wrapper">
            <div class="inputTitle">{{ $t("probel.hospitalBranchCode") }}</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    v-model="clone.hospitalBranchId"
                    :show-attributes="true"
                    :max-character-count="64"
                    :show-emoji="false"
                    :placeholder="$t('probel.hospitalBranchCodeDesc')"
                    :rows="1"
                />
            </div>
        </div>
        <div class="inputTitle mt-5 mb-2 font-weight-bold">{{ $t("chatbotv2.followingAttributesFilled") }}</div>
        <section class="next-step-filled-items-wrapper">
            <div class="logos middle-section" v-for="attr in nextStepFilledValue" :key="attr">
                <AttributeIconPreview :attribute="attr" />
                <span class="ml-2">
                    <AttributeLabel :attribute="attr" />
                </span>
            </div>
        </section>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import AttributeLabel from "../../common/tiptap-extensions/AttributeLabel";
import AttributeIconPreview from "../../common/AttributeIconPreview";

import _ from "lodash";

const log = log2("ProbelSelectBranch");
export default {
    name: "ProbelSelectBranch",
    components: { TiptapEditor, AttributeLabel, AttributeIconPreview },
    props: {
        value: {
            type: Object,
            default: () => ({ hospitalBranchId: "{{probel_sube_kodu}}" }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            nextStepFilledValue: ["probel_brans_kodu", "probel_brans_adi"],
        };
    },
    mounted() {
        log("mounted");
    },
    watch: {
        clone: {
            handler(val) {
                log("clone changed", val);
                this.$emit("input", val);
            },
            deep: true,
        },
        value(val) {
            if (_.isEqual(val, this.clone)) {
                return;
            }
            this.clone = _.cloneDeep(val);
        },
    },
};
</script>

<style lang="scss">
.block-editor.probel-select-branch {
    padding: 30px 30px 0;

    .active-connection {
        align-items: center;
        background: #fff;
        border-radius: 6px;
        display: flex;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 20px;
        width: 100%;
        word-break: break-word;

        .logos {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            margin-right: 15px;
            margin-top: 4px;

            .logo1 {
                background: #4a6586;
            }

            .logo2 {
                background: rgba(208, 41, 46, 0.32);
            }

            .logo1,
            .logo2 {
                height: 30px;
                padding: 4px;
                width: 30px;
            }
        }

        .filled-attributes {
            margin: 0px 0px -17px -50px !important;
        }
    }

    .next-step-filled-items-wrapper {
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        padding: 20px;
        width: 100%;

        .middle-section {
            background: #ffdc66;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            display: flex;
            justify-content: center;
            padding: 5px;
            width: fit-content;
            margin: 5px;
            align-items: center;
            font-weight: 800;
        }
    }

    .active-connection-text {
        flex-grow: 1;
        flex-shrink: 0;
        width: 0;

        div {
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: pre-wrap;
        }
    }

    .probel-select-branch-wrapper {
        .inputTitle {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .editable-editor {
            p {
                margin-bottom: 0;
            }
        }
    }
}
</style>
